import React, { useState, useEffect } from "react";
import Menu from "../../components/Menu";
import api from "../../api";
import {
  Calendar,
  Search,
  Clock,
  X,
  Check,
  User,
  FileText,
  Building2,
  AlertCircle,
  DollarSign,
  ChevronRight,
  Eye,
} from "lucide-react";
import "./Schedule.css";

// Configuração dos status de agendamento
const statusConfig = {
  agendado: {
    icon: Clock,
    color: "#ffc107",
    bgColor: "#fff3cd",
    borderColor: "#ffeaa7",
    label: "Agendado",
  },
  cancelado: {
    icon: X,
    color: "#dc3545",
    bgColor: "#f8d7da",
    borderColor: "#f5c6cb",
    label: "Cancelado",
  },
  confirmado: {
    icon: Check,
    color: "#28a745",
    bgColor: "#d4edda",
    borderColor: "#c3e6cb",
    label: "Confirmado",
  },
};

// Configuração dos status de pagamento (apenas para agendados)
const pagamentoConfig = {
  pago: {
    icon: DollarSign,
    color: "#28a745",
    bgColor: "#d4edda",
    borderColor: "#c3e6cb",
    label: "Pago",
  },
  nao_pago: {
    icon: AlertCircle,
    color: "#fd7e14",
    bgColor: "#fff3e0",
    borderColor: "#ffe0b2",
    label: "Não Pago",
  },
};

// Configuração dos status de extorno (apenas para cancelados)
const extornoConfig = {
  extornado: {
    icon: DollarSign,
    color: "#28a745",
    bgColor: "#d4edda",
    borderColor: "#c3e6cb",
    label: "Extornado",
  },
  nao_extornado: {
    icon: DollarSign,
    color: "#dc3545",
    bgColor: "#f8d7da",
    borderColor: "#f5c6cb",
    label: "Não Extornado",
  },
  nao_precisa_extornar: {
    icon: DollarSign,
    color: "#28a745",
    bgColor: "#d4edda",
    borderColor: "#c3e6cb",
    label: "Não Precisou Extornar",
  },
};

const setores = [
  "Laboratório",
  "Cardiologia",
  "Ortopedia",
  "Ginecologia",
  "Dermatologia",
  "Diagnóstico por Imagem",
];

// Dados de exemplo - múltiplos procedimentos por paciente
/*const procedimentosData = [
  {
    id: 1,
    cliente: "SOCORRO DE ABREU",
    cpf: "03479602355",
    procedimento: "Consulta Cardiológica",
    setor: "Cardiologia",
    data: "2025-06-10",
    hora: "14:30",
    empresa: "Clínica São José",
    status: "agendado",
    pagamento: "nao_pago",
  },
  {
    id: 2,
    cliente: "SOCORRO DE ABREU",
    cpf: "03479602355",
    procedimento: "Eletrocardiograma",
    setor: "Cardiologia",
    data: "2025-06-10",
    hora: "15:00",
    empresa: "Clínica São José",
    status: "agendado",
    pagamento: "pago",
  },
  {
    id: 3,
    cliente: "SOCORRO DE ABREU",
    cpf: "03479602355",
    procedimento: "Exame de Sangue",
    setor: "Laboratório",
    data: "2025-06-05",
    hora: "09:00",
    empresa: "Laboratório Central",
    status: "realizado",
  },
  {
    id: 4,
    cliente: "BRENNY EMANUELLE DO NASCIMENTO",
    cpf: "83665954550",
    procedimento: "Exame de Sangue",
    setor: "Laboratório",
    data: "2025-06-08",
    hora: "09:15",
    empresa: "Laboratório Central",
    status: "realizado",
  },
  {
    id: 5,
    cliente: "BRENNY EMANUELLE DO NASCIMENTO",
    cpf: "83665954550",
    procedimento: "Ultrassom Abdominal",
    setor: "Diagnóstico por Imagem",
    data: "2025-06-12",
    hora: "16:00",
    empresa: "Centro de Diagnóstico",
    status: "agendado",
    pagamento: "nao_pago",
  },
  {
    id: 6,
    cliente: "MARIA SILVA SANTOS",
    cpf: "12345678901",
    procedimento: "Ultrassom Abdominal",
    setor: "Diagnóstico por Imagem",
    data: "2025-06-05",
    hora: "16:00",
    empresa: "Centro de Diagnóstico",
    status: "cancelado",
    extorno: "nao_extornado",
  },
  {
    id: 7,
    cliente: "MARIA SILVA SANTOS",
    cpf: "12345678901",
    procedimento: "Consulta Ginecológica",
    setor: "Ginecologia",
    data: "2025-06-15",
    hora: "10:30",
    empresa: "Clínica Mulher",
    status: "agendado",
    pagamento: "pago",
  },
  {
    id: 8,
    cliente: "JOÃO PEDRO OLIVEIRA",
    cpf: "98765432109",
    procedimento: "Consulta Dermatológica",
    setor: "Dermatologia",
    data: "2025-06-12",
    hora: "10:45",
    empresa: "Clínica Derma Plus",
    status: "agendado",
    pagamento: "pago",
  },
];
 */
export default function PosConsultSchedule() {
  const now = new Date()
  const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)
  const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0)

  const formatDate = (date) => date.toISOString().split("T")[0]

  const [dataInicio, setDataInicio] = useState(formatDate(firstDay));
  const [dataFim, setDataFim] = useState(formatDate(lastDay));
  const [statusFiltro, setStatusFiltro] = useState("todos");
  const [pagamentoFiltro, setPagamentoFiltro] = useState("todos");
  const [pesquisa, setPesquisa] = useState("");
  const [modalAberto, setModalAberto] = useState(false);
  const [pacienteSelecionado, setPacienteSelecionado] = useState(null);
  const [setorFiltroModal, setSetorFiltroModal] = useState("todos");
  
  // **NOVOS estados**
  const [procedimentosData, setProcedimentosData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Resetar filtro de pagamento quando mudar o status
  const handleStatusChange = (novoStatus) => {
    setStatusFiltro(novoStatus);
    setPagamentoFiltro("todos");
  };

  // Agrupar procedimentos por paciente
  const agruparPorPaciente = (procedimentos) => {
    console.log("Procedimentos dentro do agruparPorPaciente", procedimentos);
    const grupos = {};

    for (const proc of procedimentos) {
      console.log("Procedimento dentro do for", proc);
      const chave = proc.cpf;

      // Se o grupo não existe, cria um novo
      if (!grupos[chave]) {
        grupos[chave] = {
          cliente: proc.cliente,
          cpf: proc.cpf,
          procedimentos: [],
          totalProcedimentos: 0,
          statusCount: {
            agendado: 0,
            realizado: 0,
            cancelado: 0,
          },
        };
      }

      // Adiciona o procedimento ao grupo
      grupos[chave].procedimentos.push(proc);
      grupos[chave].totalProcedimentos += 1;

      // Incrementa o contador de status apropriado
      if (proc.status === "agendado") {
        grupos[chave].statusCount.agendado += 1;
      } else if (proc.status === "confirmado") {
        grupos[chave].statusCount.realizado += 1;
      } else if (proc.status === "cancelado") {
        grupos[chave].statusCount.cancelado += 1;
      }
    }

    // Converte o objeto em array
    return Object.values(grupos);
  };

  const agruparPorSetor = (procedimentos) => {
    const grupos = {};

    for (const proc of procedimentos) {
      if (!grupos[proc.setor]) {
        grupos[proc.setor] = [];
      }
      grupos[proc.setor].push(proc);
    }

    return grupos;
  };

  const procedimentosFiltrados = procedimentosData.filter((p) => {
    // filtro de texto (pesquisa)
    const termo = pesquisa.trim().toLowerCase();
    if (termo) {
      const cliente = p.cliente?.toLowerCase() || "";
      const cpf = p.cpf?.toLowerCase() || "";
      const procedimento = p.procedimento?.toLowerCase() || "";
      const setor = p.setor?.toLowerCase() || "";
      const matches =
        cliente.includes(termo) ||
        cpf.includes(termo) ||
        procedimento.includes(termo) ||
        setor.includes(termo);
      if (!matches) return false;
    }

    // status
    if (statusFiltro !== "todos" && p.status !== statusFiltro) return false;
    // pagamento (só aplica quando status for "agendado")
    if (
      statusFiltro === "agendado" &&
      pagamentoFiltro !== "todos" &&
      p.pagamento !== pagamentoFiltro
    )
      return false;
    return true;
  });

  console.log("Procedimentos filtrados", procedimentosFiltrados);

  const pacientesAgrupados = agruparPorPaciente(procedimentosFiltrados);

  const formatarCPF = (cpf) => {
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  };

  const formatarData = (data) => {
    return new Date(data).toLocaleDateString("pt-BR");
  };

  const abrirModal = (paciente) => {
    setPacienteSelecionado(paciente);
    setModalAberto(true);
  };

  const fecharModal = () => {
    setModalAberto(false);
    setPacienteSelecionado(null);
    setSetorFiltroModal("todos");
  };

  // **FETCH NA API**
  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      try {
        const payload = {
          status: statusFiltro,
          start_date: dataInicio, // certifique-se que está no formato YYYY-MM-DD
          end_date: dataFim,
        };

        const response = await api.post(
          "/api/schedulings/filter-by-status",
          payload
        );

        const schedulings = response.data?.data || [];

        if (schedulings && Array.isArray(schedulings)) {
          const flat = schedulings.flatMap((scheduling) => {
            if (!scheduling.items || !Array.isArray(scheduling.items))
              return [];

            return scheduling.items.map((item) => {
              const status = item.cancel
                ? "cancelado"
                : item.confirmed
                ? "confirmado"
                : "agendado";

              return {
                id: item.procedure_id,
                cliente: scheduling.customer_name,
                cpf: scheduling.customer_cpf,
                procedimento: item.procedure_name,
                setor: item.setor || "—",
                data: item.date_scheduling,
                hora: item.time_booked,
                empresa: item.executing_company,
                status,
                pagamento: item.is_paid ? "pago" : "nao_pago",
                extorno:
                  item.refunded === true
                    ? "extornado"
                    : item.is_paid === false
                    ? "nao_precisa_extornar"
                    : "nao_extornado",
              };
            });
          });

          setProcedimentosData(flat);
        } else {
          console.error("Dados inválidos retornados da API:", schedulings);
          setProcedimentosData([]);
        }
      } catch (err) {
        console.error("Erro ao buscar agendamentos:", err);
        setProcedimentosData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [statusFiltro, dataInicio, dataFim]);

  useEffect(() => {
    console.log("Pacientes", procedimentosData);
    console.log("Status", statusFiltro);
    console.log("Pagamento", pagamentoFiltro);
    console.log("Procedimentos Filtrados", procedimentosFiltrados);
    console.log("Pesquisa", pesquisa);
    console.log("Data Início", dataInicio);
    console.log("Data Fim", dataFim);
  }, [
    procedimentosData,
    statusFiltro,
    pagamentoFiltro,
    pesquisa,
    dataInicio,
    dataFim,
  ]);

  const screenTela = (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f8f9fa",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}>
      {/* Header */}
      <div
        style={{
          backgroundColor: "white",
          padding: "20px 30px",
          borderBottom: "1px solid #e9ecef",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <Calendar size={24} color="#6c757d" />
          <h1
            style={{
              margin: 0,
              fontSize: "24px",
              fontWeight: "600",
              color: "#495057",
            }}>
            Pós-Consultório - Agenda
          </h1>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Calendar size={16} color="#6c757d" />
          <span style={{ fontSize: "14px", color: "#6c757d" }}>06/06/2025</span>
        </div>
      </div>

      <div style={{ padding: "30px" }}>
        {/* Filtros */}
        <div
          style={{
            backgroundColor: "white",
            padding: "25px",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            marginBottom: "25px",
          }}>
          {/* Barra de Pesquisa */}
          <div style={{ marginBottom: "20px" }}>
            <div style={{ position: "relative", maxWidth: "400px" }}>
              <Search
                size={20}
                color="#6c757d"
                style={{
                  position: "absolute",
                  left: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              />
              <input
                type="text"
                placeholder="Pesquisar Paciente (Nome ou CPF)"
                value={pesquisa}
                onChange={(e) => setPesquisa(e.target.value)}
                style={{
                  width: "100%",
                  padding: "12px 12px 12px 40px",
                  border: "1px solid #ced4da",
                  borderRadius: "6px",
                  fontSize: "14px",
                  outline: "none",
                }}
              />
            </div>
          </div>

          {/* Filtros de Data e Status */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                statusFiltro === "agendado"
                  ? "repeat(auto-fit, minmax(180px, 1fr))"
                  : "repeat(auto-fit, minmax(200px, 1fr))",
              gap: "20px",
              alignItems: "end",
            }}>
            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#495057",
                }}>
                Data Início
              </label>
              <input
                type="date"
                value={dataInicio}
                onChange={(e) => setDataInicio(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #ced4da",
                  borderRadius: "6px",
                  fontSize: "14px",
                }}
              />
            </div>

            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#495057",
                }}>
                Data Fim
              </label>
              <input
                type="date"
                value={dataFim}
                onChange={(e) => setDataFim(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #ced4da",
                  borderRadius: "6px",
                  fontSize: "14px",
                }}
              />
            </div>

            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#495057",
                }}>
                Status
              </label>
              <select
                value={statusFiltro}
                onChange={(e) => handleStatusChange(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #ced4da",
                  borderRadius: "6px",
                  fontSize: "14px",
                  backgroundColor: "white",
                }}>
                <option value="todos">Todos</option>
                <option value="agendado">Agendados</option>
                <option value="cancelado">Cancelados</option>
                <option value="confirmado">Confirmados</option>
              </select>
            </div>

            {statusFiltro === "agendado" && (
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#495057",
                  }}>
                  Pagamento
                </label>
                <select
                  value={pagamentoFiltro}
                  onChange={(e) => setPagamentoFiltro(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ced4da",
                    borderRadius: "6px",
                    fontSize: "14px",
                    backgroundColor: "white",
                  }}>
                  <option value="todos">Todos</option>
                  <option value="pago">Pago</option>
                  <option value="nao_pago">Não Pago</option>
                </select>
              </div>
            )}
          </div>
        </div>

        {/* Lista de Pacientes */}
        <div className="schedule-table-container">
          {
            loading ? (
              <p>Carregando dados ...</p>
            ) : (
              pacientesAgrupados.length === 0 ? (
                <div
                  style={{
                    backgroundColor: "white",
                    padding: "40px",
                    borderRadius: "8px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    textAlign: "center",
                    color: "#6c757d",
                  }}>
                  <Calendar
                    size={48}
                    color="#dee2e6"
                    style={{ marginBottom: "16px" }}
                  />
                  <p style={{ margin: 0, fontSize: "16px" }}>
                    Nenhum paciente encontrado para os filtros selecionados.
                  </p>
                </div>
              ) : (
                pacientesAgrupados.map((paciente) => (
                  <div
                    key={paciente.cpf}
                    style={{
                      backgroundColor: "white",
                      padding: "20px",
                      borderRadius: "8px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      border: "1px solid #e9ecef",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                    }}
                    onClick={() => abrirModal(paciente)}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow =
                        "0 4px 8px rgba(0,0,0,0.15)";
                      e.currentTarget.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "20px",
                      }}>
                      {/* Informações do Paciente */}
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            marginBottom: "12px",
                          }}>
                          <User size={20} color="#6c757d" />
                          <div>
                            <h3
                              style={{
                                margin: 0,
                                fontSize: "18px",
                                fontWeight: "600",
                                color: "#495057",
                              }}>
                              {paciente.cliente}
                            </h3>
                            <p
                              style={{
                                margin: 0,
                                fontSize: "14px",
                                color: "#6c757d",
                              }}>
                              CPF: {formatarCPF(paciente.cpf)}
                            </p>
                          </div>
                        </div>
    
                        {/* Contadores de Status */}
                        <div
                          style={{
                            display: "flex",
                            gap: "16px",
                            alignItems: "center",
                          }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                            }}>
                            <FileText size={16} color="#6c757d" />
                            <span
                              style={{
                                fontSize: "14px",
                                color: "#495057",
                                fontWeight: "500",
                              }}>
                              {paciente.totalProcedimentos} procedimento(s)
                            </span>
                          </div>
    
                          {paciente.statusCount.agendado > 0 && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                padding: "4px 8px",
                                backgroundColor: "#fff3cd",
                                borderRadius: "12px",
                              }}>
                              <Clock size={12} color="#ffc107" />
                              <span
                                style={{
                                  fontSize: "12px",
                                  color: "#ffc107",
                                  fontWeight: "500",
                                }}>
                                {paciente.statusCount.agendado}
                              </span>
                            </div>
                          )}
    
                          {paciente.statusCount.realizado > 0 && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                padding: "4px 8px",
                                backgroundColor: "#d4edda",
                                borderRadius: "12px",
                              }}>
                              <Check size={12} color="#28a745" />
                              <span
                                style={{
                                  fontSize: "12px",
                                  color: "#28a745",
                                  fontWeight: "500",
                                }}>
                                {paciente.statusCount.realizado}
                              </span>
                            </div>
                          )}
    
                          {paciente.statusCount.cancelado > 0 && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                padding: "4px 8px",
                                backgroundColor: "#f8d7da",
                                borderRadius: "12px",
                              }}>
                              <X size={12} color="#dc3545" />
                              <span
                                style={{
                                  fontSize: "12px",
                                  color: "#dc3545",
                                  fontWeight: "500",
                                }}>
                                {paciente.statusCount.cancelado}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
    
                      {/* Botão Ver Detalhes */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          padding: "8px 16px",
                          backgroundColor: "#e9ecef",
                          borderRadius: "20px",
                          color: "#495057",
                        }}>
                        <Eye size={16} />
                        <span style={{ fontSize: "14px", fontWeight: "500" }}>
                          Ver Detalhes
                        </span>
                        <ChevronRight size={16} />
                      </div>
                    </div>
                  </div>
                ))
              )
            )
          }
        </div>

        {/* Resumo */}
        {pacientesAgrupados.length > 0 && (
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              marginTop: "25px",
              textAlign: "center",
            }}>
            <p
              style={{
                margin: 0,
                fontSize: "14px",
                color: "#6c757d",
              }}>
              Exibindo {pacientesAgrupados.length} paciente(s) com{" "}
              {procedimentosFiltrados.length} procedimento(s) total
            </p>
          </div>
        )}
      </div>

      {/* Modal de Detalhes do Paciente */}
      {modalAberto && pacienteSelecionado && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: "20px",
          }}
          onClick={fecharModal}>
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "12px",
              maxWidth: "900px",
              width: "100%",
              maxHeight: "85vh",
              overflow: "hidden",
              boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)",
            }}
            onClick={(e) => e.stopPropagation()}>
            {/* Header do Modal */}
            <div
              style={{
                padding: "24px",
                borderBottom: "1px solid #e9ecef",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}>
              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#495057",
                  }}>
                  {pacienteSelecionado.cliente}
                </h2>
                <p
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    color: "#6c757d",
                  }}>
                  CPF: {formatarCPF(pacienteSelecionado.cpf)} •{" "}
                  {pacienteSelecionado.totalProcedimentos} procedimento(s)
                </p>
              </div>
              <button
                onClick={fecharModal}
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "24px",
                  cursor: "pointer",
                  color: "#6c757d",
                  padding: "4px",
                }}>
                ×
              </button>
            </div>

            {/* Filtro por Setor */}
            <div
              style={{
                padding: "20px 24px",
                borderBottom: "1px solid #e9ecef",
                backgroundColor: "#f8f9fa",
              }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}>
                <label
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#495057",
                  }}>
                  Filtrar por Setor:
                </label>
                {/* <select
                  value={setorFiltroModal}
                  onChange={(e) => setSetorFiltroModal(e.target.value)}
                  style={{
                    padding: "8px 12px",
                    border: "1px solid #ced4da",
                    borderRadius: "6px",
                    fontSize: "14px",
                    backgroundColor: "white",
                    minWidth: "200px",
                  }}>
                  <option value="todos">Todos os Setores</option>
                  {setores.map((setor) => (
                    <option key={setor} value={setor}>
                      {setor}
                    </option>
                  ))}
                </select> */}
              </div>
            </div>

            {/* Lista de Procedimentos */}
            <div
              style={{
                padding: "24px",
                maxHeight: "55vh",
                overflowY: "auto",
              }}>
              {(() => {
                // Filtrar procedimentos por setor
                const procedimentosFiltradosModal =
                  setorFiltroModal === "todos"
                    ? pacienteSelecionado.procedimentos
                    : pacienteSelecionado.procedimentos.filter(
                        (proc) => proc.setor === setorFiltroModal
                      );

                // Agrupar por setor
                const procedimentosAgrupados = agruparPorSetor(
                  procedimentosFiltradosModal
                );
                const setoresComProcedimentos = Object.keys(
                  procedimentosAgrupados
                ).sort();

                if (procedimentosFiltradosModal.length === 0) {
                  return (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "40px",
                        color: "#6c757d",
                      }}>
                      <FileText
                        size={48}
                        color="#dee2e6"
                        style={{ marginBottom: "16px" }}
                      />
                      <p style={{ margin: 0, fontSize: "16px" }}>
                        Nenhum procedimento encontrado para o setor selecionado.
                      </p>
                    </div>
                  );
                }

                return (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "24px",
                    }}>
                    {setoresComProcedimentos.map((setor) => (
                      <div key={setor}>
                        {/* Cabeçalho do Setor */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            marginBottom: "12px",
                            padding: "8px 12px",
                            backgroundColor: "#e9ecef",
                            borderRadius: "6px",
                          }}>
                          <Building2 size={16} color="#495057" />
                          <h3
                            style={{
                              margin: 0,
                              fontSize: "16px",
                              fontWeight: "600",
                              color: "#495057",
                            }}>
                            {setor}
                          </h3>
                          <span
                            style={{
                              fontSize: "12px",
                              color: "#6c757d",
                              backgroundColor: "#fff",
                              padding: "2px 8px",
                              borderRadius: "10px",
                              border: "1px solid #dee2e6",
                            }}>
                            {procedimentosAgrupados[setor].length}{" "}
                            procedimento(s)
                          </span>
                        </div>

                        {/* Procedimentos do Setor */}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px",
                            marginLeft: "16px",
                          }}>
                          {procedimentosAgrupados[setor].map((procedimento) => {
                            const statusConfigItem =
                              statusConfig[procedimento.status];
                            const StatusIcon = statusConfigItem.icon;

                            const pagamentoConfigItem =
                              procedimento.status === "agendado" &&
                              procedimento.pagamento
                                ? pagamentoConfig[procedimento.pagamento]
                                : null;
                            const PagamentoIcon = pagamentoConfigItem?.icon;

                            return (
                              <div
                                key={procedimento.id}
                                style={{
                                  padding: "16px",
                                  border: `1px solid ${statusConfigItem.borderColor}`,
                                  borderRadius: "8px",
                                  backgroundColor: "#fafafa",
                                }}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    justifyContent: "space-between",
                                    gap: "16px",
                                  }}>
                                  <div style={{ flex: 1 }}>
                                    <h4
                                      style={{
                                        margin: "0 0 8px 0",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                        color: "#495057",
                                      }}>
                                      {procedimento.procedimento}
                                    </h4>

                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "12px",
                                        marginBottom: "6px",
                                      }}>
                                      <Calendar size={14} color="#6c757d" />
                                      <span
                                        style={{
                                          fontSize: "14px",
                                          color: "#495057",
                                        }}>
                                        {formatarData(procedimento.data)} às{" "}
                                        {procedimento.hora}
                                      </span>
                                    </div>

                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "12px",
                                      }}>
                                      <Building2 size={14} color="#6c757d" />
                                      <span
                                        style={{
                                          fontSize: "14px",
                                          color: "#495057",
                                        }}>
                                        {procedimento.empresa}
                                      </span>
                                    </div>
                                  </div>

                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "8px",
                                      alignItems: "flex-end",
                                    }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        padding: "6px 12px",
                                        backgroundColor:
                                          statusConfigItem.bgColor,
                                        border: `1px solid ${statusConfigItem.borderColor}`,
                                        borderRadius: "16px",
                                        whiteSpace: "nowrap",
                                      }}>
                                      <StatusIcon
                                        size={14}
                                        color={statusConfigItem.color}
                                      />
                                      <span
                                        style={{
                                          fontSize: "12px",
                                          fontWeight: "500",
                                          color: statusConfigItem.color,
                                        }}>
                                        {statusConfigItem.label}
                                      </span>
                                    </div>

                                    {procedimento.status === "agendado" &&
                                      pagamentoConfigItem &&
                                      PagamentoIcon && (
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                            padding: "4px 10px",
                                            backgroundColor:
                                              pagamentoConfigItem.bgColor,
                                            border: `1px solid ${pagamentoConfigItem.borderColor}`,
                                            borderRadius: "12px",
                                            whiteSpace: "nowrap",
                                          }}>
                                          <PagamentoIcon
                                            size={12}
                                            color={pagamentoConfigItem.color}
                                          />
                                          <span
                                            style={{
                                              fontSize: "11px",
                                              fontWeight: "500",
                                              color: pagamentoConfigItem.color,
                                            }}>
                                            {pagamentoConfigItem.label}
                                          </span>
                                        </div>
                                      )}

                                    {procedimento.status === "cancelado" &&
                                      procedimento.extorno && (
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                            padding: "4px 10px",
                                            backgroundColor:
                                              extornoConfig[
                                                procedimento.extorno
                                              ].bgColor,
                                            border: `1px solid ${
                                              extornoConfig[
                                                procedimento.extorno
                                              ].borderColor
                                            }`,
                                            borderRadius: "12px",
                                            whiteSpace: "nowrap",
                                          }}>
                                          <DollarSign
                                            size={12}
                                            color={
                                              extornoConfig[
                                                procedimento.extorno
                                              ].color
                                            }
                                          />
                                          <span
                                            style={{
                                              fontSize: "11px",
                                              fontWeight: "500",
                                              color:
                                                extornoConfig[
                                                  procedimento.extorno
                                                ].color,
                                            }}>
                                            {
                                              extornoConfig[
                                                procedimento.extorno
                                              ].label
                                            }
                                          </span>
                                        </div>
                                      )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    ))}
                  </div>
                );
              })()}
            </div>
          </div>
        </div>
      )}
    </div>
  );
  return <Menu screen={screenTela} />;
}
